/**
 * 定义休眠函数
 * @param {number} msTime 休眠时间，毫秒
 */
export function sleep(msTime: number) {
  return new Promise((resolve) =>
    setTimeout(function () {
      resolve({
        success: true,
        time: msTime,
      })
    }, msTime),
  )
}

export function makeAsync<T extends (...args: any[]) => any>(
  syncFn: T,
): (...args: Parameters<T>) => Promise<ReturnType<T>> {
  return (...args: Parameters<T>): Promise<ReturnType<T>> => {
    return new Promise((resolve, reject) => {
      try {
        // 使用 setTimeout 将同步函数推迟执行
        setTimeout(() => {
          const result = syncFn(...args)
          resolve(result)
        }, 0)
      } catch (error) {
        reject(error)
      }
    })
  }
}
